export const MUTATION_KEYS = {
  CREATE: ['create', 'sgr', 'pruffConnect'],
  SUBMIT: ['submit', 'sgr', 'pruffConnect'],
  GET_FILE: ['get', 'sgr', 'pruffConnect'],
} as const;
